<span class="status-badge" [ngClass]="[statusClass, 'size-' + size]">
  <span *ngIf="showIcon" class="status-icon">

    <!-- Check: Passed / Completed -->
    <svg *ngIf="iconType === 'check'" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.5"/>
      <path d="M5.5 8L7 9.5L10.5 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <!-- Dot: Executing -->
    <span *ngIf="iconType === 'dot'" class="dot-ping"></span>

    <!-- Warning triangle: Failed / Aborted / Exited / Skipped -->
    <svg *ngIf="iconType === 'warning'" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 2.5L14 13.5H2L8 2.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <line x1="8" y1="7" x2="8" y2="10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <circle cx="8" cy="12" r="0.75" fill="currentColor"/>
    </svg>

    <!-- Clock: Pending / Waiting / Stopped -->
    <svg *ngIf="iconType === 'clock'" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.5"/>
      <path d="M8 4.5V8L10.5 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

  </span>
  <span class="status-text">{{ normalizedStatus }}</span>
</span>
